import { StoreConfig, EntityStore, EntityState, ActiveState } from '@datorama/akita';
import { UserStay } from './user-stays.model';

export interface UserStaysState extends EntityState<UserStay, UserStay['id']>, ActiveState {}

@StoreConfig({ name: 'user-stay', resettable: true })
export class UserStaysStore extends EntityStore<UserStaysState> {}

export const userStaysStore = new UserStaysStore();
